import { render, staticRenderFns } from "./AdminImportsScreen.vue?vue&type=template&id=1d6c4ea7&scoped=true"
import script from "./AdminImportsScreen.vue?vue&type=script&lang=js"
export * from "./AdminImportsScreen.vue?vue&type=script&lang=js"
import style0 from "./AdminImportsScreen.vue?vue&type=style&index=0&id=1d6c4ea7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c4ea7",
  null
  
)

export default component.exports